import { useCallback, useEffect, useState } from "react";
import { fetchOverviewSummary } from "../services/overviewService";

export default function useOverviewSummary(defaultDays = 30) {
	const [range, setRange] = useState(() => {
		const end = new Date();
		const start = new Date(end.getTime() - defaultDays * 24 * 60 * 60 * 1000);
		return {
			start: start.toISOString(),
			end: end.toISOString()
		};
	});
	const [paging, setPaging] = useState({ limit: 25, offset: 0 });
	const [data, setData] = useState({ metrics: [], topPages: [] });
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	const load = useCallback(async () => {
		setLoading(true);
		setError(null);
		try {
			const res = await fetchOverviewSummary({
				start: range.start,
				end: range.end,
				limit: paging.limit,
				offset: paging.offset
			});
			setData(res);
		} catch (e) {
			setError(e?.response?.data?.message || e.message || "Failed to load overview");
		} finally {
			setLoading(false);
		}
	}, [range, paging]);

	useEffect(() => { load(); }, [load]);

	return { data, loading, error, range, setRange, paging, setPaging, reload: load };
}


